import React from 'react';
import { TextField } from '@mui/material';
import { OutlinedTextFieldProps } from '@mui/material/TextField/TextField';

export interface NewCustomInputProps extends Partial<OutlinedTextFieldProps> {}

export const MuiInput = ({ ...props }: NewCustomInputProps) => {
	return <TextField variant="outlined" fullWidth {...props} />;
};
